import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { useEffect } from "react";
import { getTooltip, setLoggedIn } from "api";
import AlertBox from "components/global/AlertBox";
import OnboardingStepperNew from "./OnboardingStepperNew";
import { Route, Switch, useRouteMatch, useLocation } from "react-router-dom";

const Onboarding = ({ logged_in, brands, refresh_token, user_token, user }) => {
  const { path } = useRouteMatch();
  const { search } = useLocation();
  const postpaddyMobile = new URLSearchParams(search).get("postpaddy-mobile");
  const mobileUrl = localStorage.getItem("mobileUrl");
  const authMobileProvider = localStorage.getItem("authMobileProvider");
  const { confirm_brand_details, onboarding_completed } =
    user?.has_viewed_tooltips ?? {};

  useEffect(() => {
    getTooltip();
  }, []);

  if (!logged_in) {
    return (
      <Redirect
        to={`/sign-in?return_to=${encodeURIComponent(
          window.location.pathname + window.location.search
        )}`}
      />
    );
  }

  if (
    brands?.length &&
    onboarding_completed &&
    confirm_brand_details &&
    (postpaddyMobile || mobileUrl || authMobileProvider)
  ) {
    setLoggedIn(false);
    localStorage.removeItem("mobileUrl");
    localStorage.removeItem("authMobileProvider");
    window.location.href = `postpaddy.app://?token=${user_token}&refresh_token=${refresh_token}&success=true`;
  } else if (brands?.length && onboarding_completed && confirm_brand_details) {
    const redirect = localStorage.getItem("redirect");
    const returnTo = new URLSearchParams(search).get("return_to");

    const redirectPath = returnTo
      ? returnTo
      : Boolean(redirect) && redirect !== "null"
      ? redirect
      : undefined;

    return <Redirect to={redirectPath ?? "/dashboard/home"} />;
  }

  return (
    <>
      <AlertBox className="" />
      <Switch>
        <Route
          exact
          path={`${path}`}
          component={() => <Redirect to={`${path}/create-brand`} />}
        />
        <Route
          path={`${path}/:onboardingstep`}
          component={OnboardingStepperNew}
        />
        {/* No match */}
        <Route component={() => <Redirect to={`${path}/create-brand`} />} />
      </Switch>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    logged_in: state.logged_in,
    brands: state.brands,
    user_token: state.user_token,
    refresh_token: state.refresh_token,
  };
};

export default connect(mapStateToProps)(Onboarding);
